"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomDatePickerWidget = void 0;
var React = require("react");
var react_datepicker_1 = require("react-datepicker");
var en_GB_1 = require("date-fns/locale/en-GB");
require("react-datepicker/src/stylesheets/datepicker.scss");
var moment = require("moment");
var journey_model_1 = require("@athena-portal/journey-model");
var journey_services_1 = require("@athena-portal/journey-services");
var react_html_parser_1 = require("react-html-parser");
var services_1 = require("@falcon/services");
var FalconQuestionWidgetBase_1 = require("./FalconQuestionWidgetBase");
var InfoQuestionWrapper_1 = require("../components/infoQuestion/InfoQuestionWrapper");
var CustomDatePickerWidget = exports.CustomDatePickerWidget = /** @class */ (function (_super) {
    __extends(CustomDatePickerWidget, _super);
    function CustomDatePickerWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.bindToField = function (date) {
            var dateMoment = moment(date, moment.ISO_8601);
            var formattedDate = dateMoment.format("YYYY-MM-DD");
            if (dateMoment.isValid()) {
                _this.props.onStateChange(_this.props.question.interactionField, formattedDate);
                _this.changelogRecorder.recordQuestion("change", _this.props);
            }
            _this.validateInternal(formattedDate);
        };
        _this.handleChange = function (date) {
            _this.setState({ date: date, dateClicked: true });
        };
        _this.onClickOutside = function () {
            _this.setState({ date: _this.state.dateSelected, dateClicked: false });
            _this.refreshDatePickerHack();
        };
        _this.setDate = function () {
            if (_this.state.date) {
                _this.bindToField(_this.state.date);
                _this.calendarRef.current.setOpen(false);
                _this.executeEvent("change");
                _this.setState({ dateSelected: _this.state.date });
            }
        };
        _this.state = {
            date: null,
            dateSelected: null,
            showPreviousMonths: false,
            dateClicked: false
        };
        (0, react_datepicker_1.registerLocale)("enGB", en_GB_1.default);
        _this.minDateExpression = _this.getSetting("minDateExpression", undefined);
        _this.maxDateExpression = _this.getSetting("maxDateExpression", undefined);
        _this.footerHtml = _this.getSetting("footerHtml", undefined);
        _this.reactivationJourney = _this.getSetting("reactivationJourney", undefined);
        _this.infoHtml = _this.getSetting("infoHtml", undefined);
        _this.infoType = _this.getSetting("infoType", "collapse");
        _this.previousMtaStartDateExpression = _this.getSetting("previousMtaStartDate", undefined);
        if (_this.minDateExpression) {
            var evaluatedDate = moment(moment.utc(journey_services_1.ExpressionEvaluator.evaluateExpression(_this.minDateExpression, _this.props.interaction, null), moment.ISO_8601).format("YYYY-MM-DD"));
            if (!evaluatedDate) {
                throw Error("Invalid evaluation result for minDateExpression: ".concat(_this.minDateExpression));
            }
            _this.minDate = evaluatedDate.isAfter(moment()) ? evaluatedDate.toDate() : new Date();
            _this.originalMinDate = _this.minDate;
        }
        else {
            throw Error("".concat(_this.props.question.type, " widget is unable to obtain 'minDateExpression'"));
        }
        if (_this.maxDateExpression) {
            var maxExpressionDate = moment.utc(journey_services_1.ExpressionEvaluator.evaluateExpression(_this.maxDateExpression, _this.props.interaction, moment(30, "d").toDate()), moment.ISO_8601);
            if (_this.reactivationJourney && _this.reactivationJourney === "true" && _this.props.interaction.uistate.previousVersionStartDate) {
                var yearAfterEnd = moment.utc(_this.props.interaction.uistate.previousVersionStartDate).add(1, "y");
                var maxDate = maxExpressionDate.isSameOrBefore(yearAfterEnd) ? maxExpressionDate : yearAfterEnd;
                _this.maxDate = moment(maxDate.format("YYYY-MM-DD")).toDate();
            }
            else {
                _this.maxDate = moment(moment.utc(journey_services_1.ExpressionEvaluator.evaluateExpression(_this.maxDateExpression, _this.props.interaction, moment(30, "d").toDate()), moment.ISO_8601).format("YYYY-MM-DD")).toDate();
            }
        }
        else {
            throw Error("".concat(_this.props.question.type, " widget is unable to obtain 'maxDateExpression'"));
        }
        if (_this.previousMtaStartDateExpression) {
            var evaluatedExpression = journey_services_1.ExpressionEvaluator.evaluateExpression(_this.previousMtaStartDateExpression, _this.props.interaction, undefined);
            // a bit of a workaround as in case of invalid value ExpressionEvaluator service returns new Date(0) instead of undefined or any other invalid value
            if (evaluatedExpression.getTime() === new Date(0).getTime()) {
                _this.previousMtaStartDate = undefined;
            }
            else {
                _this.previousMtaStartDate = moment.utc(evaluatedExpression, moment.ISO_8601).toDate();
            }
        }
        _this.calendarRef = React.createRef();
        return _this;
    }
    CustomDatePickerWidget.prototype.componentDidUpdate = function () {
        var dateInNextMonth = moment(this.state.date).isAfter(new Date(), "month");
        var maxDateInMonthAfter = moment(this.state.date).isBefore(this.maxDate, "month");
        var showPreviousMonths = dateInNextMonth && !maxDateInMonthAfter;
        if (this.state.showPreviousMonths !== showPreviousMonths) {
            this.setState({ showPreviousMonths: showPreviousMonths });
        }
        if (this.bindFromField(this.props.question.interactionField) && !this.state.date) {
            this.setState({ date: moment(this.bindFromField(this.props.question.interactionField)).toDate() });
        }
    };
    CustomDatePickerWidget.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var monthsToShow;
            return __generator(this, function (_a) {
                monthsToShow = moment(this.maxDate).startOf("month").diff(moment(this.minDate).startOf("month"), "months") + 1;
                this.setState({ monthsToShow: monthsToShow });
                return [2 /*return*/];
            });
        });
    };
    CustomDatePickerWidget.prototype.render = function () {
        var htmlLabel = this.getSetting("htmlLabel", "");
        var cssClass = this.getSetting("cssClass", "");
        var label = htmlLabel ? this.renderHtml(htmlLabel) : this.props.question.label;
        if (this.infoHtml) {
            var infoContent = this.renderHtml(this.infoHtml || "");
            return (React.createElement(InfoQuestionWrapper_1.InfoQuestionWrapper, { label: label, infoType: this.infoType, info: infoContent, infoTitle: label, className: cssClass },
                this.renderInputField(),
                this.renderValidationResult()));
        }
        else {
            return (React.createElement("div", { className: "form-group ".concat(this.getSetting("cssClass", "")) },
                React.createElement("label", { className: "custom-date-picker-label", htmlFor: this.props.question.name }, label),
                React.createElement("div", { className: "input-group" },
                    this.renderInputField(),
                    this.renderValidationResult())));
        }
    };
    CustomDatePickerWidget.prototype.renderInputField = function () {
        var _this = this;
        if (this.previousMtaStartDate && services_1.productHelper.isHomeOrWolfMotor(this.props.interaction) && this.props.interaction.process !== services_1.INTERACTION_PROCESS_MTC) {
            var mtaDate_1 = moment(this.originalMinDate);
            this.dayClassName = function (date) { return moment(date).isSameOrBefore(mtaDate_1) ? "disabled" : null; };
            this.minDate = moment().toDate();
        }
        var DateInput = function (_a) {
            var value = _a.value, onClick = _a.onClick;
            return (React.createElement("div", { className: "datePickerSelect" },
                React.createElement("div", { onClick: onClick, onKeyPress: onClick },
                    React.createElement("input", { onClick: _this.executeNativeEvent, type: "radio", name: "date", value: "calendar", id: "datePickerCalendar", role: "dialog", checked: !!_this.state.date }),
                    React.createElement("label", { htmlFor: "datePickerCalendar", tabIndex: 0, "aria-label": "Choose date from calendar" },
                        _this.state.date ? value : "Please select date",
                        React.createElement("span", { className: "calendar-icon" }),
                        React.createElement("span", { className: "calendar-arrow-icon" })))));
        };
        return (React.createElement("div", { className: "form-control-datepicker" },
            React.createElement(react_datepicker_1.default, { ref: this.calendarRef, onChange: this.handleChange, selected: this.state.date, customInput: React.createElement(DateInput, null), locale: "enGB", dateFormat: "dd MMM yyyy", minDate: this.minDate, maxDate: this.maxDate, dayClassName: this.dayClassName, showPreviousMonths: this.state.dateClicked ? false : this.state.showPreviousMonths, showDisabledMonthNavigation: false, disabledKeyboardNavigation: true, shouldCloseOnSelect: false, onClickOutside: this.onClickOutside, monthsShown: this.state.monthsToShow, showPopperArrow: false, withPortal: true },
                React.createElement("div", { className: "react-datepicker__footer" }, this.renderFooterHtml()),
                React.createElement("div", { className: "d-flex justify-content-center mr-5 ml-5" }, this.renderSelectDateButton()))));
    };
    CustomDatePickerWidget.prototype.refreshDatePickerHack = function () {
        var _this = this;
        // https://github.com/Hacker0x01/react-datepicker/issues/3942
        // https://lv-digital.atlassian.net/browse/FAL-14811
        // react-datepicker has internal check for month id to show, and it is not reset when date picker is closed
        // the workaround below triggers internal month id reset
        var monthsToShow = this.state.monthsToShow;
        setTimeout(function () {
            _this.setState({ monthsToShow: 1 });
            setTimeout(function () { return _this.setState({ monthsToShow: monthsToShow }); }, 1);
        }, 1);
    };
    CustomDatePickerWidget.prototype.renderFooterHtml = function () {
        var evaluatedString = journey_services_1.ExpressionEvaluator.renderTemplate(this.footerHtml, this.props.interaction, true);
        return (0, react_html_parser_1.default)(evaluatedString, { transform: function (node) {
                if (node.name === 'script' || node.name === 'style' || node.name === 'link') {
                    return null;
                }
                return;
            } });
    };
    CustomDatePickerWidget.prototype.renderSelectDateButton = function () {
        return (React.createElement("button", { type: "button", className: "btn btn-primary btn-next-arrow-separate", onClick: this.setDate, id: "set-date", disabled: !this.state.date }, "Select date"));
    };
    CustomDatePickerWidget = __decorate([
        (0, journey_model_1.settings)([
            { name: "footerHtml", type: journey_model_1.TypeDescriptions.String },
            { name: "minDateExpression", type: journey_model_1.TypeDescriptions.String },
            { name: "maxDateExpression", type: journey_model_1.TypeDescriptions.String },
            { name: "reactivationJourney", type: journey_model_1.TypeDescriptions.String },
            { name: "nextButtonName", type: journey_model_1.TypeDescriptions.String },
            { name: "infoHtml", type: journey_model_1.TypeDescriptions.String },
            { name: "infoType", type: journey_model_1.TypeDescriptions.String }
        ]),
        __metadata("design:paramtypes", [Object])
    ], CustomDatePickerWidget);
    return CustomDatePickerWidget;
}(FalconQuestionWidgetBase_1.FalconQuestionWidgetBase));
//# sourceMappingURL=CustomDatePickerWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/CustomDatePickerWidget.js
// module id = 1338
// module chunks = 0